import { useQuery } from '@tanstack/react-query'
import React from 'react'
import * as R from 'remeda'

import { type TimeSeriesSettingsPage_MainQuery as Data } from '~/gql/graphql'
import { filterExists, pathOr } from '~/utils'

import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryCustomerAttributeOrderTable = () => {
  const queryKey = useMainQueryKey()

  const { data } = useQuery<Data>({ enabled: false, queryKey })

  return React.useMemo(
    () =>
      R.pipe(
        data,
        pathOr('brandAccount.surveys', []),
        filterExists,
        R.flatMap((survey) =>
          R.pipe(
            survey.customerAttributeGroups,
            filterExists,
            R.flatMap((customerAttributeGroup) =>
              R.pipe(
                customerAttributeGroup.customerAttributes,
                filterExists,
                R.map((customerAttribute, index) => ({
                  surveyId: survey.id,
                  customerAttributeGroupId: customerAttributeGroup.id,
                  customerAttributeId: customerAttribute.id,
                  order: index + 1,
                })),
              ),
            ),
          ),
        ),
      ),
    [data],
  )
}
